import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EditPaymentMethodActionPayload } from '@/domains/payments/features/paymentModals/modals/EditPaymentMethod/types/EditPaymentMethodActionPayload';

export const editPaymentMethodSlice = createSlice({
  name: 'editPaymentMethodSlice',
  initialState: {},
  reducers: {
    editPaymentMethod(_state, _action: PayloadAction<EditPaymentMethodActionPayload>) {},
  },
});

export const { editPaymentMethod } = editPaymentMethodSlice.actions;

export const { reducer: editPaymentMethodReducer, reducerPath: editPaymentMethodReducerPath } = editPaymentMethodSlice;
